<template>
    <div class="t-lk-modal__content t-filter__class">
        <h2 class="t-lk-modal__title">{{ props.title }}</h2>

        <div class="js-date-picker t-lk-date-picker _modal-mobile">
            <v-date-picker
                v-model="dates"
                :first-day-of-week="1"
                @input="changeDate($event)"
                :allowed-dates="disablePastDates"
                :locale="$router.history.base !== '' ? $router.history.base.substring(1) : 'ru'"
                no-title
            >
            </v-date-picker>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from "vuex";
    import Vue from "vue";

    export default {
        name: "lk-mobile-calendar",
        props: ['props'],
        data() {
            return {
                prevDates: '',
                dates: '',
            }
        },
        computed: {
            ...mapGetters('lk', ['modalDatesCalendar']),
        },
        methods: {
            ...mapMutations('lk', ['setItemLead', 'setModalDatesCalendar']),
            ...mapActions('lk', {
                lk_changeStatus: 'leads/changeStatus',
                lk_changeDate: 'leads/changeDate'
            }),
            ...mapActions('modal', [
                'modalType_lkErrorOpen',
                'modalType_changeDateOpen',
                'modalClose'
            ]),
            disablePastDates(val) {
                return val >= new Date().toISOString().substring(0, 10);
            },
            async changeDate(e) {
                this.setModalDatesCalendar(e)
                // после двух попыток модалка
                // код 1 в 1 из lk-date-lead.vue
                // спросите какого х*я? сам не знаю, было до меня...
                if (this.props.item.countChangeDate >= 2) {
                    this.dates = this.prevDates;
                    this.setModalDatesCalendar(this.prevDates);
                    this.modalType_changeDateOpen({
                        leadId: this.props.item.id,
                    });
                    return;

                }
                
                // TODO: перенес на верх, зачем этот код нужен разберусь позже
                // ВИДИМО КТО-ТО БЛЯТЬ СОБИРАЛСЯ В ОДНОЙ МОДАЛКЕ ПРОВЕРЯТЬ ПУТИ И ЧЕКАТЬ РОУТЫ...
                // СУКА! ПОРТАЛЫ ДЛЯ ДОДИКОВ ВИДИМО...
                // TODO: ЗАРЕФАКТОРИТЬ МОДАЛКИ, ИЛИ РАЗОБРАТЬСЯ ЗАЧЕМ ОНИ ТАК ДЕЛАЮТ
                // зарефакторил для лидов, сделать порталы поумнее если будет время 
                // и по ходу дела переносить все модалки в портал
                if (this.props.item.noConfirm) {
                    if (this.$route.name == 'lk-leads') {
                        await this.lk_changeStatus({
                            id: this.props.item.id,
                            status: 2,
                            date: this.modalDatesCalendar
                        })
                    } else {
                        throw new Error('ЗАРЕФАКТОРИТЬ ГРЕБАННЫЙ КАЛЕНДАРЬ');
                        // this.$parent.$parent.$children[3].$children[0].changeStatus(this.props.item, 2, this.modalDatesCalendar)
                    }
                    return;
                }

                this.setModalDatesCalendar(this.dates);
                this.prevDates = this.modalDatesCalendar;

                const { data, success } = await this.lk_changeDate({
                    id: this.props.item.id,
                    date: this.modalDatesCalendar
                })

                if (!success) {
                    this.openError(data);
                    return;
                }
                this.modalClose();

            },
            // TODO: вынести уже эти все модалки в портал и не ебать себе мозгу
            openError(data) {
                let text = this.$root.staticText.modal.errorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }

                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.modal.errorTitle2,
                    text: text,
                    closeBthNone: true
                });
                this.setModalDatesCalendar(this.prevDates);
            },
        },
        created() {
            this.prevDates = this.modalDatesCalendar;
            this.dates = this.modalDatesCalendar;
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/lk-mobile-calendar.vue